import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Aux from '../../hoc/Aux';
import MicIcon from "@material-ui/icons/Mic";
import classes from './AudioRecorder.css';
//import Recorder from 'recorder-js';

class AudioRecorder extends Component {
    state = {
        recorder: null,
        blob: null,
        materialCode: null,
        recordingCounter: 0,
        status: null,
        interval: null,
        timeout: null,
        bgAudio: null
    }

    componentDidMount() {
  //      let recorder = new Recorder(new (window.AudioContext || window.webkitAudioContext)(), {});

        this.setState({ ...this.state, recordingCounter: this.props.maxTime, recorder: this.props.recorder, materialCode: this.props.materialCode });
    }

    startRecording = () => {
        if(this.props.backgroundSound) {
            this.state.bgAudio = document.createElement("audio");
            this.state.bgAudio.src = this.props.backgroundSound;
            this.state.bgAudio.play();
        }

        clearInterval(this.state.interval);
        clearTimeout(this.state.timeout);

        this.state.recorder.start()
            .then(() => {
                this.setState({ ...this.state, recordingCounter: this.props.maxTime, status: 'RECORDING' }, () => {

                    let interval = setInterval(() => {
                        console.log("Tick Inside: " + this.state.recordingCounter);
                        this.setState({ ...this.state, recordingCounter: (--this.state.recordingCounter) });
                    }, 1000);
                    let timeout = setTimeout(() => { this.stopRecording() }, this.props.maxTime * 1000);

                    this.setState({ ...this.state, interval: interval, timeout: timeout });
                });
            }).catch(e => this.props.handleError("Wygląda na to, że masz zablokowany dostęp do mikrofonu. Aby móc nagrywać ćwiczenia, musisz wyrazić zgodę na użycie mikrofonu."));
    }

    stopRecording = () => {
        clearInterval(this.state.interval);
        clearTimeout(this.state.timeout);

        if(this.props.backgroundSound) {
            this.state.bgAudio.pause();
            this.state.bgAudio.currentTime = 0;
        }

        this.state.recorder.stop()
            .then(({ blob, buffer }) => {
                try {
                    if (blob.size == 44) {
                        this.props.handleError("Wystąpił błąd podczas nagrywania. Przepraszamy. Prosimy o ponowną próbę. Jeśli problem będzie się powtarzał, prosimy o odświeżenie aplikacji.");
                    }

                    this.setState({ ...this.state, blob: blob, status: 'STOP' });
                } catch (er) {
                }
            });
    }    

    render() {
        let mic = this.state.status == 'RECORDING' ?
            <Aux><MicIcon className={classes.Blink} style={{ fontSize: '100px', color: '#f50057' }} /><b style={{ color: '#f50057' }}>({this.state.recordingCounter})</b></Aux> :
            <Aux><MicIcon style={{ fontSize: '100px', color: '#ddd' }} /><b style={{ color: '#ddd' }}>({this.state.recordingCounter})</b></Aux>;
        return (
            <Aux>
                <div style={{ textAlign: 'center', margin: '20px' }}>{mic}</div>
                <Button id="recordButton" color="primary" disabled={this.state.status == 'RECORDING' || this.state.status == 'SENDING'} onClick={this.startRecording}>Start</Button>
                <Button id="stopButton" color="secondary" disabled={this.state.status == null || this.state.status == 'SENDING' || this.state.status == 'STOP'} onClick={this.stopRecording}>Stop</Button>
                <Button id="send" color="primary" disabled={this.state.status == null || this.state.status == 'RECORDING' || this.state.status == 'SENDING'} onClick={() => { this.props.onSend(this.props.materialCode, this.state.blob)}}>Wyślij</Button>
            </Aux>);
    }
}

export default AudioRecorder; 